import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface ListingProps {
    listingType: string;
    vendors: any
    listing: any
    listingUpgrader: any
    listings: []
    loader: boolean
    listingCreated: any
    user_slug?: string
    searchTerms: {
        type: string
        miles: number
        placeId: string
    }
}

const initialState: ListingProps = {
    listingType: "producer",
    vendors: [],
    listings: [],
    listing: "",
    listingUpgrader: null,
    loader: false,
    listingCreated: undefined,
    user_slug: undefined,
    searchTerms: {
        type: '',
        miles: 0,
        placeId: ''
    }
}

const ListingSlice = createSlice({
    name: 'listing',
    initialState,
    reducers: {
        setListingType(state, action: PayloadAction<string>) {
            state.listingType = action.payload;
        },
        setListing(state, action: PayloadAction<string>) {
            state.listing = action.payload;
        },
        setUpgradingListing(state, action: PayloadAction<string>) {
            state.listingUpgrader = action.payload;
        },
        setResetUpgradingListing(state, action) {
            state.listingUpgrader = action.payload || null;
        },
        setListings(state, action: PayloadAction<string>) {
            state.listing = action.payload;
        },
        setSearchTerms(state, action: PayloadAction<any>) {
            state.searchTerms = action.payload
        },
        setVendors(state, action: PayloadAction<any>) {
            const vendorToAdd = action.payload;
            if (state.vendors.length === 0) {
                return
            }
            // Check if the vendor with the same id already exists in the array
            const existingVendorIndex = state.vendors.findIndex((vendor: any) => vendor.id === vendorToAdd.id);
            if (existingVendorIndex === -1 && Object.keys(vendorToAdd).length !== 0) {
                // If it doesn't exist, push the new vendor
                state.vendors.push(vendorToAdd);
            } else {
                // If it exists, update the existing vendor with the new data
                state.vendors.splice(existingVendorIndex, 1);

            }
        },
        setLoader(state, action: PayloadAction<boolean>) {
            state.loader = action.payload;
        },
        setListingCreated(state, action: PayloadAction<any>) {
            state.listingCreated = action.payload
        },
        setUserSlug: (state, action) => {
            state.user_slug = action.payload
        },
    }
})

export const { 
    setListingType, 
    setListings, 
    setListingCreated, 
    setVendors, 
    setListing, 
    setLoader, 
    setSearchTerms, 
    setUpgradingListing, 
    setResetUpgradingListing,
    setUserSlug 
} = ListingSlice.actions;
export default ListingSlice.reducer
